import Vue from 'vue';

Vue.component('melissa-feedback-index', () =>
    import(/* webpackChunkName: 'melissa-feedback-index' */ './melissa-feedback-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/melissa-feedback/index.js